export class Role {
    id = '';

    roleName = '';

    permissions = [];
}
